import(/* webpackMode: "eager" */ "/tmp/8de4e9f39ca2c4f/app/[locale]/error.tsx");
